<template>
  <div class="dcp-no-results-message">
    <div class="dcp-no-results-message__content">
      <h3 class="dcp-no-results-message__headline">{{ $t('dcp.srp.noResult.headline') }}</h3>
      <p class="dcp-no-results-message__message">{{ $t('dcp.srp.noResult.message') }}</p>
      <button
        class="dcp-no-results-message__cta wb-button wb-button--secondary wb-button--small"
        @click="handleResetFilters"
      >
        {{ $t('dcp.srp.noResult.cta') }}
      </button>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'NoResultMessage',
  emits: ['clear-all-filters'],
  setup(_props, { emit }) {
    const handleResetFilters = (): void => {
      emit('clear-all-filters');
    };

    return {
      handleResetFilters,
    };
  },
});
</script>
<style lang="scss" src="./noResultsMessage.scss"></style>
